module.exports = __webpack_public_path__ + "img/news1.e6ec3906.png";